import React, { useState, useEffect } from 'react';
import './Avaliacao.css';
import Select from 'react-select';
import { fetchGroupersData } from '../../services/api/fetchGrouper';
import { sendEvaluationData } from '../../services/api/fetchGrouper';
import { fetchGroupers } from '../../services/api/fetchGrouper';
import { fetchClientSubjects } from '../../services/api/fetchGrouper';
import { RiRobot2Line } from "react-icons/ri";
import AuditLogHistory from '../AuditLogHistory/AuditLogHistory';

function Avaliacao({ clientId, clippingId, onClose, onAddFilter, loadExistingData, evaluatedBy, userProfile, showLegend = false }) {
  const [groupers, setGroupers] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [evaluatedByAiFields, setEvaluatedByAiFields] = useState([]);
  const [approvedMeta, setApprovedMeta] = useState({});
  const [approvedNames, setApprovedNames] = useState([]);
  const [subjectQuery, setSubjectQuery] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [activeTab, setActiveTab] = useState('form'); // 'form' or 'history'

  const getGroupers = async () => {
    try {
      const response = await fetchGroupers(clientId);
      const sortedGroupers = response.sort((a, b) => a.id - b.id);
      setGroupers(sortedGroupers);

      if (loadExistingData) {
        const evaluationData = await fetchGroupersData(clippingId);
        const initialValues = {};
        const metaByGrouper = {};
        const namesSet = new Set();

        evaluationData.forEach((item) => {
          const gid = item?.grouper_detail?.id;
          const fieldType = item?.grouper_detail?.field_type;
          const val = (item?.value ?? "").toString();

          const shouldApply = Array.isArray(clippingId)
            ? clippingId.includes(item.clipping)
            : item.clipping == clippingId;

          if (!shouldApply) return;

          if (fieldType === "select") {
            const prev = initialValues[gid];
            const prevArr = Array.isArray(prev) ? prev : prev ? [prev] : [];

            const merged = [...prevArr, val]
              .map((v) => String(v || "").trim())
              .filter(Boolean);

            initialValues[gid] = Array.from(new Set(merged));
          } else {
            initialValues[gid] = val;
          }

          metaByGrouper[gid] = {
            approved_by_name: item.approved_by_name,
            approval_status: item.approval_status,
            approval_date: item.approval_date,
          };

          if (item.approved_by_name) {
            namesSet.add(String(item.approved_by_name).trim());
          }
        });

        setSelectedValues(initialValues);
        setApprovedMeta(metaByGrouper);
        setApprovedNames(Array.from(namesSet));

        const evaluatedByAi = evaluationData
          .filter((item) => item.evaluated_by_ai)
          .map((item) => item.grouper_detail.id);

        setEvaluatedByAiFields(evaluatedByAi);
      }

      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar groupers:", error);
      setLoading(false);
    }
  };

  
  useEffect(() => {
    getGroupers();
  }, [clientId, clippingId, loadExistingData]);
  
  

  const handleInputChange = (id, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleAddFilter = async () => {
    const filters = groupers
      .flatMap((grouper) => {
        const raw = selectedValues[grouper.id];

        if (Array.isArray(raw)) {
          return raw
            .map((v) => (v || "").trim())
            .filter(Boolean)
            .map((v) => `${grouper.id}:${v}`);
        }

        const value = (raw || "").toString().trim();
        return value ? [`${grouper.id}:${value}`] : [];
      })
      .filter(Boolean);

    const clippingIdsArray = Array.isArray(clippingId) ? clippingId : [clippingId];

    const filterData = {
      client: clientId,
      clippings: clippingIdsArray,
      filters,
    };

    console.log("Dados enviados para a API:", filterData);

    try {
      const response = await sendEvaluationData(filterData);
      console.log("Resposta da API:", response);
      setMessage("Avaliação realizada com sucesso!");
      setError("");
    } catch (error) {
      console.error("Erro ao enviar dados para a API:", error);
      console.error("Detalhes do erro:", error.response);
      setMessage("");
      setError("Erro ao realizar a avaliação. Por favor, tente novamente.");
    }

    onAddFilter(filterData);
    onClose();
  };

  const handleNumberInputChange = (id, value) => {
    let numericValue = value.replace(/\D/g, '');
    if (numericValue) {
      numericValue = `R$ ${numericValue}`;
    }
    setSelectedValues({
      ...selectedValues,
      [id]: numericValue
    });
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      padding: '10px',
      fontSize: '14px',
      borderColor: state.isFocused ? '#ccc' : '#ccc',
      borderRadius: '4px',
      backgroundColor: 'white',
      color: '#333',
      outline: 'none',
      boxShadow: state.isFocused ? '0 0 0 1px #ccc' : 'none',
      transition: 'border-color 0.3s, box-shadow 0.3s',
      '&:hover': {
        borderColor: '#ccc',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#eee' : '#fff',
      color: '#333',
      padding: '10px',
      '&:active': {
        backgroundColor: '#eee',
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 2,
    }),
  };

   useEffect(() => {
      if (!clientId) return;
        const q = subjectQuery.trim();
        if (q.length < 3) {
          setSubjects([]);
          return;
        }
        setIsTyping(true);

        const handler = setTimeout(async () => {
          try {
            const res = await fetchClientSubjects(clientId, q);
            setSubjects(res?.subjects || []);
          } catch (e) {
            console.error('Erro ao buscar assuntos:', e);
          } finally {
            setIsTyping(false);
          }
        }, 800);

        return () => clearTimeout(handler);
      }, [clientId, subjectQuery]);

if (loading) {
  return (
    <section
      className="container_avaliacao"
      style={{ position: 'relative', minHeight: 420 }}
      aria-busy="true"
      aria-live="polite"
    >

      <div className="modal-loading-overlay-avaliacao">
        <div className="modal-loading-card-avaliacao">
          <div className="ring-loader-avaliacao" aria-hidden="true"></div>
          <p className="loading-text-avaliacao">
            Carregando avaliação<span className="dots-avaliacao" aria-hidden="true">...</span>
          </p>
        </div>
      </div>
    </section>
  );
}

  const splitFiltersIntoColumns = () => {
    const numColumns = 2;
    const filtersPerColumn = Math.ceil(groupers.length / numColumns);
    const columns = [];

    for (let i = 0; i < numColumns; i++) {
      columns.push(groupers.slice(i * filtersPerColumn, (i + 1) * filtersPerColumn));
    }

    return columns;
  };

  const columns = splitFiltersIntoColumns();

  // Check if clippingId is a single value (not array) to show history tab
  // Only administrators and employees can access audit log history
  const canAccessAuditLog = userProfile === 'administrador' || userProfile === 'funcionario';
  const showHistoryTab = !Array.isArray(clippingId) && loadExistingData && canAccessAuditLog;

  return (
    <section className="container_avaliacao">
      <button className="close-button_avaliacao" aria-label="Close" onClick={onClose}>x</button>
      <h1 className="title_avaliacao">Avaliação</h1>
      <hr className='hr'></hr>

      {showLegend && userProfile !== 'cliente' && userProfile !== 'cliente_admin' && (
        <div className="legend-box-avaliacao">
          <h3 className="legend-title-avaliacao">Legenda:</h3>
          <div className="legend-item-avaliacao">
            <RiRobot2Line className="legend-icon-avaliacao" />
            <span className="legend-text-avaliacao">Campos avaliados automaticamente por IA</span>
          </div>
        </div>
      )}

      {showHistoryTab && (
        <div className="avaliacao-tabs">
          <button
            className={`avaliacao-tab ${activeTab === 'form' ? 'active' : ''}`}
            onClick={() => setActiveTab('form')}
          >
            Avaliação
          </button>
          <button
            className={`avaliacao-tab ${activeTab === 'history' ? 'active' : ''}`}
            onClick={() => setActiveTab('history')}
          >
            Histórico
          </button>
        </div>
      )}

      {activeTab === 'history' && showHistoryTab ? (
        <AuditLogHistory clippingId={clippingId} />
      ) : (
      <>
      <div className="filters_container_avaliacao">
        {columns.map((column, index) => (
          <div key={index} className="filter-column">
            {column.map(grouper => (
              <div key={grouper.id} className={`date-picker-filters-avaliacao ${grouper.field_type === 'text' ? 'full-width' : ''}`}>
                <div className="date-picker-label-filters-avaliacao">
                  {grouper.name}
                  {loadExistingData && evaluatedByAiFields.includes(grouper.id) && userProfile !== 'cliente' && userProfile !== 'cliente_admin' &&(
                    <RiRobot2Line style={{ marginLeft: '6px', color: '#121926', width: '12px', height: '12px' }} title="Avaliado por IA" />
                  )}
                </div>
                {grouper.field_type === "select" && grouper.values_list && (
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    styles={customStyles}
                    value={
                      Array.isArray(selectedValues[grouper.id])
                        ? selectedValues[grouper.id].map((v) => ({ value: v, label: v }))
                        : []
                    }
                    onChange={(selectedOptions) => {
                      const values = Array.isArray(selectedOptions)
                        ? selectedOptions.map((o) => o.value)
                        : [];
                      handleInputChange(grouper.id, values);
                    }}
                    options={grouper.values_list.map((option) => ({
                      value: option.value,
                      label: option.value,
                    }))}
                    placeholder="Selecione..."
                  />
                )}
                {grouper.field_type === 'radio' && grouper.values_list && (
                  grouper.values_list.map((option, index) => (
                    <div key={index} className="feature_avaliacao">
                      <input
                        type="radio"
                        id={`${grouper.id}-${index}`}
                        name={`feature-${grouper.id}`}
                        value={option.value}
                        className="radio-item_avaliacao"
                        checked={selectedValues[grouper.id] === option.value}
                        onChange={(e) => handleInputChange(grouper.id, e.target.value)}
                      />
                      <label htmlFor={`${grouper.id}-${index}`} className="feature-label_avaliacao">
                        {option.value}
                      </label>
                    </div>
                  ))
                )}
                {grouper.field_type === 'number' && (
                  <input
                    type="text"
                    className="custom-select-tema"
                    placeholder="Digite a valoração"
                    value={selectedValues[grouper.id] || ''}
                    onChange={(e) => handleNumberInputChange(grouper.id, e.target.value)}
                  />
                )}
                {grouper.field_type === 'text' && grouper.name === 'Assunto' && (
                  <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                    <input
                      type="text"
                      className="custom-select-tema"
                      placeholder="Digite ou selecione um assunto"
                      value={selectedValues[grouper.id] || ''}
                      onChange={(e) => {
                        const v = e.target.value;
                        handleInputChange(grouper.id, v);
                        setSubjectQuery(v);
                        setIsTyping(true);
                      }}
                      onFocus={() => setDropdownOpen(true)}
                      onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
                      maxLength={40}
                    />
                    {dropdownOpen && (
                      <ul
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          minWidth: '168px',
                          maxHeight: '170px',
                          overflowY: 'auto',
                          backgroundColor: 'white',
                          border: '1px solid #ccc',
                          zIndex: 1000,
                          listStyle: 'none',
                          marginTop: -17,
                          padding: '5px 0',
                          borderRadius: '5px',
                        }}
                      >
                        {subjectQuery.trim().length < 3 && (
                          <li style={{ padding: '8px 10px', color: '#666' }}>
                            Digite pelo menos 3 letras…
                          </li>
                        )}
                        {subjectQuery.trim().length >= 3 && isTyping && (
                          <li style={{ padding: '8px 10px', color: '#666' }}>
                            Buscando…
                          </li>
                        )}
                        {subjectQuery.trim().length >= 3 && !isTyping && subjects.length === 0 && (
                          <li style={{ padding: '8px 10px', color: '#666' }}>
                            Nenhum assunto encontrado
                          </li>
                        )}
                        {subjectQuery.trim().length >= 3 && subjects.map((subject, index) => (
                          <li
                            key={`${subject}-${index}`}
                            style={{
                              padding: '5px 10px',
                              cursor: 'pointer',
                              backgroundColor:
                                subject === selectedValues[grouper.id] ? '#121926' : 'white',
                              color:
                                subject === selectedValues[grouper.id] ? 'white' : '#121926',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#121926';
                              e.currentTarget.style.color = 'white';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                subject === selectedValues[grouper.id] ? '#121926' : 'white';
                              e.currentTarget.style.color =
                                subject === selectedValues[grouper.id] ? 'white' : 'black';
                            }}
                            onMouseDown={() => {
                              handleInputChange(grouper.id, subject);
                              setSubjectQuery(subject);
                            }}
                          >
                            {subject}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
                {grouper.field_type === 'text' && grouper.name !== 'Assunto' && (
                  <input
                    type="text"
                    className="custom-select-tema"
                    placeholder="Texto"
                    value={selectedValues[grouper.id] || ''}
                    onChange={(e) => handleInputChange(grouper.id, e.target.value)}
                  />
                )}
                {approvedMeta[grouper.id]?.approved_by_name && userProfile !== 'cliente' && userProfile !== 'cliente_admin' &&(
                  <p className="approved-by-text">
                    Aprovado por: {approvedMeta[grouper.id].approved_by_name}
                    {approvedMeta[grouper.id].approval_date ? (
                      <span className="approved-date"> ({approvedMeta[grouper.id].approval_date})</span>
                    ) : null}
                  </p>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}

      <div className="buttons_container_avaliacao">
        <button className="block-rate_avaliacao" aria-label="Avaliar noticias em bloco" onClick={handleAddFilter}>
          Avaliar Noticias
        </button>
        <button className="cancel-button_avaliacao" aria-label="Cancelar" onClick={onClose}>
          Cancelar
        </button>
      </div>

      {evaluatedBy && userProfile !== 'cliente' && userProfile !== 'cliente_admin' && (
        <div className="evaluated-by-container">
          <p>Avaliado por:</p>
          <span className="evaluator-by-name">{evaluatedBy}</span>
        </div>
      )}

      {approvedNames.length > 0 && userProfile !== 'cliente' && userProfile !== 'cliente_admin' && (
        <div className="evaluated-by-container">
          <p>Aprovado por:</p>
          <span className="evaluator-by-name">
            {approvedNames.join(', ')}
          </span>
        </div>
      )}
      </>
      )}
    </section>
  );
}

export default Avaliacao;
